import * as React from 'react';
import { useIntl } from 'react-intl';
import { getCustomersNamesByIds } from '../../Customers/CustomerService';

interface IComponentProps {
  item: {
    name: string;
    type: string;
    customerId: number;
    vehicles: { vehicleCustomerIds: number[] };
  };
  customers: any;
  customerIdsInGroup: null | number[];
}

function Header(props: IComponentProps): JSX.Element {
  const { formatMessage: f } = useIntl();
  const [customerIds, setCustomerIds] = React.useState<number[]>(
    props.item ? props.item.vehicles.vehicleCustomerIds : []
  );

  React.useEffect(() => {
    if (props.customerIdsInGroup) {
      if (String(props.item.type) === 'public') {
        if (props.customerIdsInGroup.length > 0) {
          setCustomerIds(props.customerIdsInGroup);
        } else {
          setCustomerIds([props.item?.customerId]);
        }
      } else {
        setCustomerIds(props.customerIdsInGroup);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.customerIdsInGroup]);

  const getCustomerNames = () => {
    const names = getCustomersNamesByIds(props.customers, customerIds);
    return names === '' ? '' : ` (${names})`;
  };

  return (
    <span className="row no-gutters b-accordion-header-content">
      <span className="col-12 col-md-auto mb-2 mb-md-0">
        <strong>{props.item.name}</strong>{' '}
        <span className="d-none d-md-inline">&nbsp;- &nbsp;</span>
      </span>
      <span className="col">
        {String(props.item.type) === 'public'
          ? f({ id: 'carsGroups.customer' })
          : f({ id: 'carsGroups.user' })}
        {getCustomerNames()}
      </span>
    </span>
  );
}

export default Header;
